import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0499e99d"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "carTop"
};
const _hoisted_2 = {
  style: {
    "font-size": "28px"
  }
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1));
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "margin-top": "-19px",
    "width": "100%",
    "height": "20px",
    "border-top-left-radius": "20px",
    "border-top-right-radius": "20px",
    "z-index": "9999",
    "background-color": "#f2f2f2"
  }
}, null, -1));
const _hoisted_5 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_space = _resolveComponent("van-space");
  const _component_van_col = _resolveComponent("van-col");
  const _component_van_row = _resolveComponent("van-row");
  const _component_van_button = _resolveComponent("van-button");
  const _component_van_tabbar_item = _resolveComponent("van-tabbar-item");
  const _component_van_tabbar = _resolveComponent("van-tabbar");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_van_row, {
    justify: "center",
    gutter: "22",
    style: {
      "background-color": "#Fdd100",
      "height": "120px"
    }
  }, {
    default: _withCtx(() => [_createVNode(_component_van_col, {
      span: "22"
    }, {
      default: _withCtx(() => [_createVNode(_component_van_space, {
        direction: "vertical",
        fill: "",
        style: {
          "margin-top": "20px"
        }
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("span", _hoisted_2, "您好！" + _toDisplayString($setup.Name), 1), _createTextVNode(), _hoisted_3, _createElementVNode("span", null, _toDisplayString($setup.CustomerName), 1)])]),
        _: 1
      })]),
      _: 1
    })]),
    _: 1
  }), _hoisted_4, _createVNode(_component_van_row, {
    justify: "center",
    gutter: "20",
    style: {
      "margin-top": "20px"
    }
  }, {
    default: _withCtx(() => [_createVNode(_component_van_col, {
      span: "20"
    }, {
      default: _withCtx(() => [_withDirectives(_createVNode(_component_van_space, {
        direction: "vertical",
        fill: ""
      }, {
        default: _withCtx(() => [_createVNode(_component_van_button, {
          type: "primary",
          size: "large",
          onClick: _cache[0] || (_cache[0] = $event => $options.ToUrl('Repair')),
          color: "#Fdd100",
          style: {
            "color": "#333333"
          }
        }, {
          default: _withCtx(() => [_createTextVNode("線上報修")]),
          _: 1
        }), _createVNode(_component_van_button, {
          type: "primary",
          size: "large",
          onClick: _cache[1] || (_cache[1] = $event => $options.ToUrl('Preserve')),
          color: "#333333",
          style: {
            "color": "#Fdd100"
          }
        }, {
          default: _withCtx(() => [_createTextVNode("預約保養")]),
          _: 1
        }), _createVNode(_component_van_button, {
          type: "primary",
          size: "large",
          onClick: _cache[2] || (_cache[2] = $event => $options.ToUrl('ServiceRecord')),
          color: "#D7D7D7",
          style: {
            "color": "#333333"
          }
        }, {
          default: _withCtx(() => [_createTextVNode("服務記錄")]),
          _: 1
        })]),
        _: 1
      }, 512), [[_vShow, $setup.IsIn == 1]])]),
      _: 1
    })]),
    _: 1
  }), _createVNode(_component_van_tabbar, {
    modelValue: $setup.active,
    "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => $setup.active = $event)
  }, {
    default: _withCtx(() => [_createVNode(_component_van_tabbar_item, {
      replace: "",
      icon: "cart-o",
      onClick: _cache[3] || (_cache[3] = $event => $options.TabChage('HomeIndex'))
    }, {
      default: _withCtx(() => [_createTextVNode("服務中心")]),
      _: 1
    }), _createVNode(_component_van_tabbar_item, {
      replace: "",
      onClick: _cache[4] || (_cache[4] = $event => $options.TabChage('UE'))
    }, {
      icon: _withCtx(props => [_createElementVNode("img", {
        src: props.active == 1 ? 'https://lineqa.cml-tw.com.tw/wj-active.png' : 'https://lineqa.cml-tw.com.tw/wj-inactive.png'
      }, null, 8, _hoisted_5)]),
      default: _withCtx(() => [_createTextVNode("二手設備 ")]),
      _: 1
    }), _createVNode(_component_van_tabbar_item, {
      replace: "",
      icon: "contact",
      onClick: _cache[5] || (_cache[5] = $event => $options.TabChage('CustomerInfo'))
    }, {
      default: _withCtx(() => [_createTextVNode("會員訊息")]),
      _: 1
    })]),
    _: 1
  }, 8, ["modelValue"])], 64);
}